import {EmailModel} from '@supermove/models';

const getFromLine = (email: EmailModel) => {
  const uniqueFromName = !!email.fromName && email.fromName !== email.fromEmail;
  return `${uniqueFromName ? email.fromName : ''}${uniqueFromName ? ` <${email.fromEmail}>` : email.fromEmail}`;
};

export default getFromLine;
